import React from 'react';
import {
  HR,
  Label,
  BoldLabel,
  PaymentBreakDownRow,
  PaymentBreakDownWrapper,
  Title,
  Note,
} from './PaymentBreakdownDetails.styles';
import { formatCurrency } from '../../../../../utils/CurrencyUtils';

const PaymentBreakdownDetails = (props: {
  currentPaymentDue: number;
  lateCharges: number;
  insufficientFundFees: number;
  total: number;
}) => {
  const { currentPaymentDue, lateCharges, insufficientFundFees, total } = props;

  const paymentBreakDown = 'Payment Breakdown';
  const currentPaymentDueLabel = 'Current Payment Due';
  const lateChargesLabel = 'Late Charges';
  const insufficientFundFeesLabel = 'Insufficient Funds Fee';
  const totalLabel = 'Total';
  const contactNotice = 'Contact Bridgecrest for payoff information.';

  return (
    <PaymentBreakDownWrapper>
      <Title>{paymentBreakDown}</Title>
      <PaymentBreakDownRow>
        <Label>{currentPaymentDueLabel}</Label>
        <Label>{formatCurrency(currentPaymentDue)}</Label>
      </PaymentBreakDownRow>
      <PaymentBreakDownRow>
        <Label>{lateChargesLabel}</Label>
        <Label>{formatCurrency(lateCharges)}</Label>
      </PaymentBreakDownRow>
      <PaymentBreakDownRow>
        <Label>{insufficientFundFeesLabel}</Label>
        <Label>{formatCurrency(insufficientFundFees)}</Label>
      </PaymentBreakDownRow>
      <PaymentBreakDownRow>
        <BoldLabel>{totalLabel}</BoldLabel>
        <BoldLabel>{formatCurrency(total)}</BoldLabel>
      </PaymentBreakDownRow>
      <HR />
      <Note>{contactNotice}</Note>
    </PaymentBreakDownWrapper>
  );
};

export default PaymentBreakdownDetails;
